import { FlexContainer } from '@taxdown/piccolo-web';
import styled, { css } from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

const startStyles = css`
  background-color: ${({ theme: { system } }) =>
    system.background.fds_sys_color_background_secondary};
  justify-content: center;
  padding-bottom: ${({ theme: { spacing } }) => spacing.spacing_32};
  overflow: hidden;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    margin: 0;
    border-radius: 0;
  }
`;

const TYPES = {
  start: startStyles,
};

export const Content = styled(FlexContainer)`
  position: relative;
  flex: 2;
  padding: 30px;
  padding-bottom: ${({ theme: { reference } }) => reference.dimension_16};
  border-radius: 14px;
  border: 1px solid #e1e1e8;
  ${({ type }) => type && TYPES[type]}
  z-index: 1;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    border: none;
    padding: 0px;
  }
`;
